export default __webpack_public_path__ + "static/media/Neophyte's Boots of Imperial Assent.ab5847a9.jpg";